import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';
const QuoteBlock = ({ params, caseName = '' }) => {
    return (
        <FullWrapper className={caseName}>
            <div className="quote-block">
                <p dangerouslySetInnerHTML={{ __html: params.text }} />
                <div className="quote-block__men">
                    <img className="quote-block__photo" src={params.photo} alt={params.alt} />
                    <div className="quote-block__info">
                        <div
                            className="quote-block__name"
                            dangerouslySetInnerHTML={{ __html: params.name }}
                        />
                        <div
                            className="quote-block__job"
                            dangerouslySetInnerHTML={{ __html: params.job }}
                        />
                    </div>
                </div>
            </div>
        </FullWrapper>
    );
};

export default QuoteBlock;
